import React from "react";
import RevealText from "../Comman/RevealText";

export default function WhyBuyNFTs() {
  return (
    <>
      <div
        className="tp-award-area ab-award-style pt-120 pb-120"
        id="nft-benefits"
      >
        <div className="container container-1480 ">
          <h2 className="tp-section-title-90 tp_text_invert tp_fade_bottom text-yellow-new">
            Why Buy Kryptogram NFTs
          </h2>
          <div className="row">
            <div className="col-xl-5 col-lg-5 col-md-12">
              <div className="text-center">
                <img
                  className=""
                  src="assets/img/one/why_buy_kryptogram_nfts.png"
                  alt=""
                />
              </div>
            </div>
            <div
              className="col-xl-7 col-lg-7 col-md-12"
              style={{ paddingTop: "86px" }}
            >
              <div className="tp-award-list-wrap">
                <div className="tp-award-list-item d-flex align-items-center justify-content-between active tp_fade_bottom">
                  <div className="tp-award-list-content-left d-flex align-items-center pt-10 pb-10">
                    <p>First-Ever NFT with Real-World Land Ownership</p>
                  </div>
                </div>
                <div className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom">
                  <div className="tp-award-list-content-left d-flex align-items-center pt-10 pb-10">
                    <p> Exclusive Entry to Tribe O Crypto Festival</p>
                  </div>
                </div>
                <div className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom">
                  <div className="tp-award-list-content-left d-flex align-items-center pt-10 pb-10">
                    <p> Ultra-Limited Supply Ensuring High Demand</p>
                  </div>
                </div>
                <div className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom">
                  <div className="tp-award-list-content-left d-flex align-items-center pt-10 pb-10">
                    <p> Future Blockchain Rewards & Staking Opportunities</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
